module.exports = __webpack_public_path__ + "static/media/cielorrasos.010535a9.jpg";